let hide = {
  "ui:options": {
    label: false,
    hide: true,
  },
}

export const setHiddenFields = (hideFieldsArr = [], exceptions = []) => {
  let ret = {}
  let exceptSet = new Set(exceptions)

  hideFieldsArr.forEach((key) => {
    if (!exceptSet.has(key)) {
      ret[key] = {
        ...hide,
      }
    }
  })

  return ret
}

export const getPreviewStyles = (schema) => {
  schema.protocol = {
    ...schema.protocol,
    "ui:options": {
      ...schema.protocol["ui:options"],
      classNames: {
        ...schema.protocol["ui:options"].classNames,
        objectTitleContainer: "rjs-h1-container pt-24 pr-24 pb-24 m-0",
      },
    },
  }
  schema.protocol.protocol_id["ui:options"] = {
    ...schema.protocol.protocol_id["ui:options"],
    classNames: {
      // fieldContainer: "w-50p pr-8 pb-8",
    },
  }
  schema.protocol.type_of_research["ui:options"] = {
    ...schema.protocol.type_of_research["ui:options"],
    classNames: {
      // fieldContainer: "w-50p pr-8 pb-8",
    },
  }
  schema.protocol.study_type["ui:options"] = {
    ...schema.protocol.study_type["ui:options"],
    classNames: {
      // fieldContainer: "rjs-full pr-8 pb-8",
      // field: "rjs-col-1-2 pr-8"
    },
  }

  if (schema?.protocol?.contact_information?.collaborators?.["ui:options"]) {
    schema.protocol.contact_information.collaborators["ui:options"].classNames = {
      fieldContainer: "rjs-full",
    }
  }

  if (schema?.protocol?.study_arms?.interventions) {
    schema.protocol.study_arms.interventions = {
      ...hide,
    }
  }

  return schema
}

export const hideStudyDetailsKeys = {
  root: [
    "unapproved_new_formulation_marketed_compound",
    "availability_expanded_access",
    "is_clinical_study",
    "vendor",
    "vendor_contact",
    "acquired_from",
    "transferred_to",
    "proprietary_name",
    "established_name",
    "product_manufactured",
    "compound_code",
    "generic_name",
    "brand_name",
    "primary_cro",
    "us_fda_regulated_drug_product",
    "us_fda_regulated_device_product",
    "secondary_ids",
    "general",
    "status",
    "protocol_amendments",
    "study_details_detailed_description",
    "sponsoring_division",
    "sponsoring_unit",
    "ctms_study_type",
    "ctms_study_title",
    "ctms_study_status",
    "study_termination_decision_date",
    "study_termination_reason",
    "study_termination_date",
    "study_other",
    "complex_study_program",
    "same_study_design",
    "post_study_access",
    "study_extension",
    "plsrs_posted_on_sponsor_website_off_lslv",
    "plsrs_posted_on_sponsor_website_off_pcd",
    "public_disclosure_synopsis_posted_on_sponsor_website",
    "post_authorization_study_type",
    "disease_area_stronghold",
  ],
  milestone_dates: {
    root: ["conception_date", "pra", "csr", "fsa", "recruitment_end_date", "first_patient_enrolled_date"],
  },
  secondary_attributes: {
    root: [
      "usa",
      "internal",
      "germany",
      "spain",
      "netherlands",
      "mexico",
      "south_korea",
      "japan",
      "united_kingdom",
      "australia_and_newzealand",
      "south_africa",
      "switzerland",
      "china",
    ],
    europe: {
      root: [
        "eu_marketing_authorization",
        "ema_cta_date",
        "ema_cta",
        "pass_category",
        "pediatric_study",
        "eu_pip",
        "date_of_latest_approval",
        "part_of_an_agreed_pip",
        "date_of_cta",
        "date_of_results",
        "eu_subsequent_marketing_authorization_application_date",
        "marketing_authorization_holder_for_the_product_under_investigation",
        "pass",
        "eudract_interim_results_required",
        "trial_ongoing_in_eu_eea_on_after_jan312025",
        "sponsor_opted_for_submission_per_eu_directive",
        "cta_submission_per_eu_directive_complete",
        "intermediate_result_analysis_specified_in_protocol",
        "date_of_initial_application_cta_submitted_in_eu_eea",
        "lpo_interim_analysis",
        "applicable_eu_regulation",
        "eu_article_41",
        "eu_article_45",
        "eu_article_46",
        "intermediate_data_analysis_date",
      ],
      lpo_eu_eea: {
        root: ["baseline", "actual"],
      },
    },
  },
}

export const hideStudyDetailsFields = () => {
  return {
    unapproved_new_formulation_marketed_compound: {
      ...hide,
    },
    availability_expanded_access: {
      ...hide,
    },
    is_clinical_study: {
      ...hide,
    },
    vendor: {
      ...hide,
    },
    vendor_contact: {
      ...hide,
    },
    acquired_from: {
      ...hide,
    },
    transferred_to: {
      ...hide,
    },
    proprietary_name: {
      ...hide,
    },
    established_name: {
      ...hide,
    },
    product_manufactured: {
      ...hide,
    },
    compound_code: {
      ...hide,
    },
    generic_name: {
      ...hide,
    },
    brand_name: {
      ...hide,
    },
    primary_cro: {
      ...hide,
    },
    us_fda_regulated_drug_product: {
      ...hide,
    },
    us_fda_regulated_device_product: {
      ...hide,
    },
    secondary_ids: {
      ...hide,
    },
    general: {
      ...hide,
    },
    status: {
      ...hide,
    },
    milestone_dates: {
      "ui:options": {
        title: "Milestone Dates",
        classNames: {
          fieldContainer: "rjs-full",
          objectContainer: "pl-24 pr-24 pb-13",
          objectTitle: "rjs-h2 p-0 mt-8 mb-8",
        },
      },
      conception_date: {
        ...hide,
      },
      pra: {
        ...hide,
      },
      fpi: {
        "ui:options": {
          title: "Study Start Date",
          classNames: {
            objectTitle: "rjs-h3",
            fieldContainer: "rjs-col-1-2",
          },
        },
        baseline: {
          "ui:options": {
            title: "Baseline",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
        forecast: {
          "ui:options": {
            title: "Forecast",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
        actual: {
          "ui:options": {
            title: "Actual",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
      },
      lpo: {
        "ui:options": {
          title: "LPO/LPLV/SCD/Global end of trial date",
          classNames: {
            objectTitle: "rjs-h3",
            fieldContainer: "rjs-col-1-2",
          },
        },
        baseline: {
          "ui:options": {
            title: "Baseline",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
        forecast: {
          "ui:options": {
            title: "Forecast",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
        actual: {
          "ui:options": {
            title: "Actual",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
      },
      pcd: {
        "ui:options": {
          title: "PCD",
          classNames: {
            objectTitle: "rjs-h3",
            fieldContainer: "rjs-col-1-2",
          },
        },
        baseline: {
          "ui:options": {
            title: "Baseline",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
        forecast: {
          "ui:options": {
            title: "Forecast",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
        actual: {
          "ui:options": {
            title: "Actual",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
      },
      csr: {
        ...hide,
      },
      fsa: {
        ...hide,
      },
      recruitment_end_date: {
        ...hide,
      },
      first_patient_enrolled_date: {
        ...hide,
      },
    },
    secondary_attributes: {
      ...hide,
    },
    protocol_amendments: {
      ...hide,
    },
    study_details_detailed_description: {
      ...hide,
    },
  }
}

export const hideSecondaryAttributeFields = (props) => {
  let lpo_eu_eea = {
    "ui:options": {
      title: "Estimated end of trial date in EEA",
      classNames: {
        // fieldContainer: "rjs-full pl-24 pr-24 pb-24",
        objectContainer: "rjs-full",
        objectTitle: "rjs-h3",
        fieldContainer: "rjs-col-1-2",
      },
    },
    baseline: {
      ...hide,
    },
    forecast: {
      "ui:options": {
        title: "Forecast",
        label: false,
        classNames: {
          fieldContainer: "rjs-col-1-2",
        },
      },
      "ui:widget": "date",
    },
    actual: {
      ...hide,
    },
  }

  if (props?.isGlobal) {
    lpo_eu_eea = {
      "ui:options": {
        title: "Estimated end of trial date in EEA",
        classNames: {
          objectContainer: "rjs-full",
          objectTitle: "rjs-h3",
          fieldContainer: "rjs-col-1-2",
        },
      },
      baseline: {
        ...hide,
      },
      forecast: {
        "ui:options": {
          title: "Forecast",
          label: false,
          classNames: {
            field: "rjs-col-date",
          },
        },
        "ui:widget": "date",
      },
      actual: {
        ...hide,
      },
    }
  }

  return {
    secondary_attributes: {
      "ui:options": {
        classNames: {
          fieldContainer: "rjs-full pl-24 pr-24 pb-24",
        },
      },
      usa: {
        ...hide,
      },
      internal: {
        ...hide,
      },
      europe: {
        classNames: {
          fieldContainer: "rjs-full",
        },
        "ui:options": {
          classNames: {
            fieldContainer: "rjs-full",
          },
        },
        eu_marketing_authorization: {
          ...hide,
        },
        ema_cta_date: {
          ...hide,
        },
        ema_cta: {
          ...hide,
        },
        pass_category: {
          ...hide,
        },
        pediatric_study: {
          ...hide,
        },
        eu_pip: {
          ...hide,
        },
        date_of_latest_approval: {
          ...hide,
        },
        part_of_an_agreed_pip: {
          ...hide,
        },
        date_of_cta: {
          ...hide,
        },
        date_of_results: {
          ...hide,
        },
        eu_subsequent_marketing_authorization_application_date: {
          ...hide,
        },
        marketing_authorization_holder_for_the_product_under_investigation: {
          ...hide,
        },
        pass: {
          ...hide,
        },
        eudract_interim_results_required: {
          ...hide,
        },
        trial_ongoing_in_eu_eea_on_after_jan312025: {
          ...hide,
        },
        sponsor_opted_for_submission_per_eu_directive: {
          ...hide,
        },
        cta_submission_per_eu_directive_complete: {
          ...hide,
        },
        intermediate_result_analysis_specified_in_protocol: {
          ...hide,
        },
        date_of_initial_application_cta_submitted_in_eu_eea: {
          ...hide,
        },
        lpo_interim_analysis: {
          ...hide,
        },
        lpo_eu_eea,
      },
      germany: {
        ...hide,
      },
      spain: {
        ...hide,
      },
      netherlands: {
        ...hide,
      },
      mexico: {
        ...hide,
      },
      south_korea: {
        ...hide,
      },
      japan: {
        ...hide,
      },
      united_kingdom: {
        ...hide,
      },
      australia_and_newzealand: {
        ...hide,
      },
      south_africa: {
        ...hide,
      },
      switzerland: {
        ...hide,
      },
      china: {
        ...hide,
      },
    },
  }
}

export const hideStudyDetailsFieldsInCtis = () => {
  return {
    unapproved_new_formulation_marketed_compound: {
      ...hide,
    },
    availability_expanded_access: {
      ...hide,
    },
    is_clinical_study: {
      ...hide,
    },
    vendor: {
      ...hide,
    },
    vendor_contact: {
      ...hide,
    },
    acquired_from: {
      ...hide,
    },
    transferred_to: {
      ...hide,
    },
    proprietary_name: {
      ...hide,
    },
    established_name: {
      ...hide,
    },
    product_manufactured: {
      ...hide,
    },
    compound_code: {
      ...hide,
    },
    generic_name: {
      ...hide,
    },
    brand_name: {
      ...hide,
    },
    primary_cro: {
      ...hide,
    },
    us_fda_regulated_drug_product: {
      ...hide,
    },
    us_fda_regulated_device_product: {
      ...hide,
    },
    secondary_ids: {
      ...hide,
    },
    general: {
      ...hide,
    },
    status: {
      ...hide,
    },
    milestone_dates: {
      "ui:options": {
        title: "Milestone Dates",
        classNames: {
          fieldContainer: "rjs-full",
          objectContainer: "pl-24 pr-24 pb-13",
          objectTitle: "rjs-h2 p-0 mt-8 mb-8",
        },
      },
      conception_date: {
        ...hide,
      },
      pra: {
        ...hide,
      },
      fpi: {
        ...hide,
      },
      lpo: {
        "ui:options": {
          title: "Estimated global end of trial date",
          classNames: {
            objectTitle: "rjs-h3",
            fieldContainer: "rjs-col-1-2",
          },
        },
        baseline: {
          ...hide,
        },
        forecast: {
          "ui:options": {
            title: "Forecast",
            label: false,
            classNames: {
              field: "rjs-col-date",
            },
          },
          "ui:widget": "date",
        },
        actual: {
          ...hide,
        },
      },
      pcd: {
        ...hide,
      },
      csr: {
        ...hide,
      },
      fsa: {
        ...hide,
      },
      recruitment_end_date: {
        ...hide,
      },
      first_patient_enrolled_date: {
        ...hide,
      },
    },
    secondary_attributes: {
      ...hide,
    },
    protocol_amendments: {
      ...hide,
    },
    study_details_detailed_description: {
      ...hide,
    },
  }
}
